import { FC } from 'react';
import { InvestigateAddress, InvestigationHistory } from '@/components';

import styles from './Investigations.module.sass';

interface InvestigationsProps {}

const Investigations: FC<InvestigationsProps> = () => {
  return (
    <div className={styles.dashboard}>
      <InvestigateAddress />
      <InvestigationHistory />
    </div>
  );
};

export default Investigations;
